module.exports = __webpack_public_path__ + "static/media/1.7fd7a17b.png";